import React from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { required } from '../../util/validators';
import classNames from 'classnames';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import { findOptionsForSelectFilter } from '../../util/search';
import { propTypes } from '../../util/types';
import config from '../../config';
import { Button, FieldCheckboxGroup, Form, FieldSelect, FieldTextInput } from '../../components';

import css from './EditListingFeaturesForm.module.css';

const EditListingFeaturesFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const {
        disabled,
        ready,
        rootClassName,
        className,
        name,
        handleSubmit,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        filterConfig,
        intl,
      } = formRenderProps;

      const classes = classNames(rootClassName || css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = disabled || submitInProgress;

      const { updateListingError, showListingsError } = fetchErrors || {};
      const errorMessage = updateListingError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingFeaturesForm.updateFailed" />
        </p>
      ) : null;

      const errorMessageShowListing = showListingsError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingFeaturesForm.showListingFailed" />
        </p>
      ) : null;

      const accessLabel = intl.formatMessage({
        id: 'EditListingAccessForm.accessLabel',
      });

      const accessPeriodLabel = intl.formatMessage({
        id: 'EditListingAccessForm.accessPeriodLabel',
      });

      const parkingWayToOpenLabelMessage = intl.formatMessage({
        id: 'EditListingPracticalInfoForm.parkingWayToOpenLabel',
      });

      const parkingWayToOpenPlaceholderMessage = intl.formatMessage({
        id: 'EditListingPracticalInfoForm.parkingWayToOpenPlaceholder',
      });

      const accessRequired = required(
        intl.formatMessage({
          id: 'EditListingAccessForm.accessRequired',
        })
      );

      const options = findOptionsForSelectFilter('amenities', filterConfig);
      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessage}
          {errorMessageShowListing}

          {/* <FieldCheckboxGroup className={css.features} id={name} name={name} options={options} /> */}

          <FieldSelect
            className={css.access}
            name="bookingType"
            id="bookingType"
            label={accessLabel}
            // validate={accessRequired}
          >
            <option disabled hidden value="">
              {'Choisissez une option'}
            </option>
            <option key={'instant'} value={'instant'}>
              {'J’opte pour les locations en arrivées autonomes'}
            </option>
            <option key={'request'} value={'request'}>
              {'J’opte pour la remise des accès en main propre'}
            </option>
          </FieldSelect>

          <FieldTextInput
            id="parkingWayToOpen"
            name="parkingWayToOpen"
            className={css.policy}
            type="textarea"
            label={parkingWayToOpenLabelMessage}
            placeholder={parkingWayToOpenPlaceholderMessage}
          />

          {/* <FieldSelect
          className={css.access}
          name="accessPeriod"
          id="accessPeriod"
          label={accessPeriodLabel}
          validate={accessRequired}
        >
          <option disabled value="">
            {" "}
          </option>
            <option key={"oui"} value={"oui"}>
              {"oui"}
            </option>
            <option key={"non"} value={"non"}>
              {"non"}
            </option>
         
        </FieldSelect> */}
          <p className={css.notMandatoryWarning}>
            Ces informations ne sont pas obligatoires, n'hésitez pas à appuyer sur "suivant" si vous
            ne souhaitez pas les compléter
          </p>

          <Button
            className={css.submitButton}
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabled}
            ready={submitReady}
          >
            {saveActionMsg}
          </Button>
        </Form>
      );
    }}
  />
);

EditListingFeaturesFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  fetchErrors: null,
  filterConfig: config.custom.filters,
};

EditListingFeaturesFormComponent.propTypes = {
  intl: intlShape.isRequired,
  rootClassName: string,
  className: string,
  name: string.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  filterConfig: propTypes.filterConfig,
};

const EditListingFeaturesForm = EditListingFeaturesFormComponent;
export default compose(injectIntl)(EditListingFeaturesForm);
